// Angular Files
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class TellerOnlineFocusRestorationService {

    private _saved = new Map<string, {
        element: HTMLElement,
        parent: HTMLElement
    }>();

    constructor(
        @Inject(DOCUMENT) private document: Document
    ) {}

    /**
     * Saves the currently focused element under the
     * given tag. Optionally captures a parent container
     * (via selector) for fallback restoration when the
     * original element is removed from the DOM.
     */
    save(tag: string, parentSelector?: string): void {
        const element =
            this.document.activeElement as HTMLElement;

        const parent = parentSelector
            ? element?.closest(
                parentSelector
            ) as HTMLElement
            : null;

        this._saved.set(tag, { element, parent });
    }

    /**
     * Restores focus for the given tag. Tries the saved
     * element first; if it was removed, tries the
     * fallback from the saved parent; if neither works,
     * falls back to #main-content-focus.
     */
    restore(
        tag: string,
        getFallback?: (
            parent: HTMLElement
        ) => HTMLElement | null
    ): void {
        const saved = this._saved.get(tag);

        this._saved.delete(tag);

        if (!saved) return;

        let target: HTMLElement = null;

        if (saved.element?.isConnected) {
            target = saved.element;
        } else if (getFallback) {
            target = getFallback(saved.parent);
        }

        target?.focus();

        if (
            !target ||
            this.document.activeElement ===
                this.document.body
        ) {
            this.document
                .querySelector<HTMLElement>(
                    '#main-content-focus'
                )
                ?.focus();
        }
    }
}
